import $ from "jquery";
import { API_HOST } from "../api_utils/index";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomQRScannerPlugin = (editor, options) => {
  if (editor !== null && editor !== undefined) {
    //Block definition
    editor.Blocks.add("custom_qr_scanner", {
      label: "QR Scanner",
      category: "Basic",
      select: true,
      media: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 256 256" xml:space="preserve">
<defs>
</defs>
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
  <path d="M 79.223 82.222 h -18.2 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 15.2 V 61.022 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 v 18.199 C 82.223 80.879 80.88 82.222 79.223 82.222 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
  <path d="M 28.978 82.222 h -18.2 c -1.657 0 -3 -1.343 -3 -3 V 61.022 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 v 15.199 h 15.2 c 1.657 0 3 1.343 3 3 S 30.634 82.222 28.978 82.222 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
  <path d="M 10.778 31.978 c -1.657 0 -3 -1.343 -3 -3 v -18.2 c 0 -1.657 1.343 -3 3 -3 h 18.2 c 1.657 0 3 1.343 3 3 s -1.343 3 -3 3 h -15.2 v 15.2 C 13.778 30.634 12.435 31.978 10.778 31.978 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
  <path d="M 79.223 31.978 c -1.657 0 -3 -1.343 -3 -3 v -15.2 h -15.2 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 18.2 c 1.657 0 3 1.343 3 3 v 18.2 C 82.223 30.634 80.88 31.978 79.223 31.978 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
  <path d="M 87 48 H 3 c -1.657 0 -3 -1.343 -3 -3 c 0 -1.657 1.343 -3 3 -3 h 84 c 1.657 0 3 1.343 3 3 C 90 46.657 88.657 48 87 48 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
</g>
</svg>`,
      content: {
        type: "custom_qr_scanner",
      },
    });

    // const qrScannerScript = function (props) {
    //   let container = this;

    //   let qrScanners = document.getElementsByClassName("qr-reader");
    //   let qrScanner = container.getElementsByClassName("qr-reader")[0];

    //   let divId = qrScanner.getAttribute("id");
    //   let qrScannersArray = Array.from(qrScanners);
    //   let matchingElement = qrScannersArray.find(
    //     (element) => element.id === divId
    //   );
    //   let matchingIndex = qrScannersArray.findIndex(
    //     (element) => element.id === divId
    //   );

    //   const startButton = container.getElementsByClassName("start-button")[0];
    //   const stopButton = container.getElementsByClassName("stop-button")[0];
    //   const resultData = container.getElementsByClassName("result-data")[0];
    //   const errorElement = container.getElementsByClassName("error")[0];

    //   const scriptId = `qrscanner-script-${matchingIndex}`;
    //   const oldScript = document.getElementById(scriptId);
    //   if (oldScript) oldScript.remove();

    //   const script = document.createElement("script");
    //   script.setAttribute("type", "text/javascript");
    //   script.setAttribute("id", scriptId);

    //   // Define the initialization function in window scope
    //   script.innerHTML = `
    //     window.initQRScanner_${matchingIndex} = function() {
    //       if (typeof Html5Qrcode !== "undefined") {
    //         const scanner = new Html5Qrcode("${divId}");
    //         window.scanner_${matchingIndex} = scanner;

    //         const config = {
    //           fps: ${props.fps || 10},
    //           qrbox: { width: ${props.qrBox || 250}, height: ${
    //     props.qrBox || 250
    //   } },
    //           aspectRatio: ${props.aspectRatio || 1.0},
    //           disableFlip: ${props.disableFlip || false},
    //           verbose: ${props.verbose || false},
    //           experimentalFeatures: {
    //             useBarCodeDetectorIfSupported: true
    //           }
    //         };

    //         window.startScanner_${matchingIndex} = async function() {
    //           try {
    //             await scanner.start(
    //               { facingMode: "environment" },
    //               config,
    //               (decodedText) => {
    //                 document.querySelectorAll('.result-data')[${matchingIndex}].textContent = decodedText;
    //               },
    //               (errorMessage) => {
    //                 const errorElement = document.querySelectorAll('.error')[${matchingIndex}];
    //                 if (!errorMessage.includes("QR code not found") &&
    //                     !errorMessage.includes("No MultiFormat Readers were able to detect the code")) {
    //                   console.error(\`QR Code scanning error: \${errorMessage}\`);
    //                   errorElement.textContent = \`Scanning error: \${errorMessage}\`;
    //                 } else {
    //                   errorElement.textContent = "";
    //                 }
    //               }
    //             );

    //             document.querySelectorAll('.start-button')[${matchingIndex}].disabled = true;
    //             document.querySelectorAll('.stop-button')[${matchingIndex}].disabled = false;
    //             document.querySelectorAll('.error')[${matchingIndex}].textContent = "";
    //           } catch (error) {
    //             console.error("Error starting scanner:", error);
    //             document.querySelectorAll('.error')[${matchingIndex}].textContent = \`Error starting scanner: \${error.message}\`;
    //           }
    //         };

    //         window.stopScanner_${matchingIndex} = async function() {
    //           try {
    //             await scanner.stop();
    //             document.querySelectorAll('.start-button')[${matchingIndex}].disabled = false;
    //             document.querySelectorAll('.stop-button')[${matchingIndex}].disabled = true;
    //             document.querySelectorAll('.result-data')[${matchingIndex}].textContent = "No QR code detected yet";
    //           } catch (error) {
    //             console.error("Error stopping scanner:", error);
    //             document.querySelectorAll('.error')[${matchingIndex}].textContent = \`Error stopping scanner: \${error.message}\`;
    //           }
    //         };
    //       }
    //     };
    //   `;

    //   document.body.appendChild(script);

    //   // Load HTML5 QR Code library
    //   const loadQRScanner = () => {
    //     const qrscannerScript = document.createElement("script");
    //     qrscannerScript.setAttribute("type", "text/javascript");
    //     qrscannerScript.setAttribute("src", "https://unpkg.com/html5-qrcode");
    //     qrscannerScript.onload = () => {
    //       window[`initQRScanner_${matchingIndex}`]();
    //       if (startButton && stopButton) {
    //         startButton.onclick = window[`startScanner_${matchingIndex}`];
    //         stopButton.onclick = window[`stopScanner_${matchingIndex}`];
    //       }
    //     };
    //     document.body.appendChild(qrscannerScript);
    //   };

    //   // Check if QR Scanner is already loaded
    //   if (!window.Html5Qrcode) {
    //     loadQRScanner();
    //   } else {
    //     window[`initQRScanner_${matchingIndex}`]();
    //     if (startButton && stopButton) {
    //       startButton.onclick = window[`startScanner_${matchingIndex}`];
    //       stopButton.onclick = window[`stopScanner_${matchingIndex}`];
    //     }
    //   }
    // };

    editor.DomComponents.addType("custom_qr_scanner", {
      model: {
        defaults: {
          tagName: "div",
          // script: qrScannerScript,
          type: "custom_qr_scanner_container",
          fps: 10,
          qrBox: 250,
          aspectRatio: 1.0,
          disableFlip: false,
          verbose: false,
          traits: [
            {
              type: "number",
              name: "fps",
              label: "FPS",
              min: 1,
              max: 60,
              changeProp: true,
            },
            {
              type: "number",
              name: "qrBox",
              label: "QR Box Size",
              min: 100,
              max: 500,
              changeProp: true,
            },
            {
              type: "number",
              name: "aspectRatio",
              label: "Aspect Ratio",
              min: 0.1,
              max: 2.0,
              step: 0.1,
              changeProp: true,
            },
            {
              type: "checkbox",
              name: "disableFlip",
              label: "Disable Flip",
              changeProp: true,
            },
            {
              type: "checkbox",
              name: "verbose",
              label: "Verbose Mode",
              changeProp: true,
            },
          ],
          "script-props": [
            "fps",
            "qrBox",
            "aspectRatio",
            "disableFlip",
            "verbose",
          ],
          changeProp: true,
          attributes: {
            class: "custom_qr_scanner_container",
          },
          "style-default": {
            width: "100%",
            height: "auto",
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
            padding: "20px",
          },
          style: {
            width: "100%",
            height: "auto",
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
            padding: "20px",
          },
          components: [
            {
              tagName: "div",
              type: "video_container",
              attributes: {
                class: "video-container",
              },
              "style-default": {
                width: "100%",
                "max-width": "640px",
                margin: "20px auto",
                "border-radius": "8px",
                overflow: "hidden",
                position: "relative",
              },
              style: {
                width: "100%",
                "max-width": "640px",
                margin: "20px auto",
                "border-radius": "8px",
                overflow: "hidden",
                position: "relative",
              },
              components: [
                {
                  tagName: "div",
                  attributes: {
                    id: "qr-reader",
                    class: "qr-reader",
                  },
                  "style-default": {
                    width: "100%",
                    "background-color": "#f0f0f0",
                  },
                  style: {
                    width: "100%",
                    "background-color": "#f0f0f0",
                  },
                },
              ],
            },
            // {
            //   tagName: "div",
            //   type: "button_container",
            //   attributes: {
            //     class: "button-container",
            //   },
            //   "style-default": {
            //     margin: "10px 0",
            //   },
            //   style: {
            //     margin: "10px 0",
            //   },
            //   components: [
            //     {
            //       tagName: "button",
            //       type: "start_button",
            //       attributes: {
            //         id: "start-button",
            //         class: "start-button",
            //       },
            //       content: "Start Scanner",
            //       "style-default": {
            //         "background-color": "#007bff",
            //         color: "white",
            //         border: "none",
            //         padding: "10px 20px",
            //         "border-radius": "5px",
            //         cursor: "pointer",
            //         margin: "5px",
            //       },
            //       style: {
            //         "background-color": "#007bff",
            //         color: "white",
            //         border: "none",
            //         padding: "10px 20px",
            //         "border-radius": "5px",
            //         cursor: "pointer",
            //         margin: "5px",
            //       },
            //     },
            //     {
            //       tagName: "button",
            //       type: "stop_button",
            //       attributes: {
            //         id: "stop-button",
            //         class: "stop-button",
            //         disabled: true,
            //       },
            //       content: "Stop Scanner",
            //       "style-default": {
            //         "background-color": "#007bff",
            //         color: "white",
            //         border: "none",
            //         padding: "10px 20px",
            //         "border-radius": "5px",
            //         cursor: "pointer",
            //         margin: "5px",
            //       },
            //       style: {
            //         "background-color": "#007bff",
            //         color: "white",
            //         border: "none",
            //         padding: "10px 20px",
            //         "border-radius": "5px",
            //         cursor: "pointer",
            //         margin: "5px",
            //       },
            //     },
            //   ],
            // },
            {
              tagName: "div",
              type: "result_container",
              attributes: {
                id: "result",
                class: "result",
              },
              "style-default": {
                margin: "20px",
                padding: "15px",
                "border-radius": "8px",
                "background-color": "#f8f9fa",
                "word-break": "break-all",
                "text-align": "left",
              },
              style: {
                margin: "20px",
                padding: "15px",
                "border-radius": "8px",
                "background-color": "#f8f9fa",
                "word-break": "break-all",
                "text-align": "left",
              },
              components: [
                {
                  tagName: "div",
                  content: "Detected QR Code:",
                  attributes: {
                    class: "result-header",
                  },
                  "style-default": {
                    "font-weight": "bold",
                    "margin-bottom": "8px",
                  },
                  style: {
                    "font-weight": "bold",
                    "margin-bottom": "8px",
                  },
                },
                {
                  tagName: "div",
                  content: "No QR code detected yet",
                  attributes: {
                    class: "result-data",
                  },
                  "style-default": {
                    "font-family": "monospace",
                    color: "#0066cc",
                  },
                  style: {
                    "font-family": "monospace",
                    color: "#0066cc",
                  },
                },
              ],
            },
            {
              tagName: "div",
              type: "error_container",
              attributes: {
                id: "error-message",
                class: "error",
              },
              "style-default": {
                color: "#dc3545",
                margin: "10px 0",
              },
              style: {
                color: "#dc3545",
                margin: "10px 0",
              },
            },
          ],
        },
      },
    });
  }
};

export default CustomQRScannerPlugin;
